import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'customer-offers-search',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const offerSearchIframe = require('./OfferSearchIframe').default
        cb(null, offerSearchIframe)
      }, 'OfferSearch')
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/OfferSearch/index.js